import { BackendProductUpsertOperationNameEnum } from "@credit-acceptance/step6-bff-client";

/** Sentinel "not listed" option for the Form Number dropdown — see `useVendorFormOptions`. */
export const MyFormNotListedOption = "My Form Not Listed" as string;

export const ProductDisplayNameMap: Record<BackendProductUpsertOperationNameEnum, string> = {
  [BackendProductUpsertOperationNameEnum.Maintenance]: "Maintenance",
  [BackendProductUpsertOperationNameEnum.TireAndWheel]: "Tire and Wheel",
  [BackendProductUpsertOperationNameEnum.KeyReplacement]: "Key Replacement",
  [BackendProductUpsertOperationNameEnum.AppearanceRepairServices]: "Appearance Repair Services",
  [BackendProductUpsertOperationNameEnum.AppearanceProtection]: "Appearance Protection",
  [BackendProductUpsertOperationNameEnum.BundledProducts]: "Bundled Products",
};
